import { mapKeySourceFor, type MapKeySource } from '@dorixona/api/maps'
import { env } from '../config/env'
import { useApi } from './context'

/**
 * Ключ Яндекс Карт: флаг `VITE_FEATURE_MAPS_KEYS` включён — только из пула на
 * сервере (пул пуст — карта показывает ошибку), выключен — ключ сборки.
 * Объект один на приложение.
 */
export function useMapKeySource(): MapKeySource {
  return mapKeySourceFor(useApi(), { pool: env.features.mapsKeys, buildKey: env.yandexMapsKey })
}
